const theme = {
  token: {
    fontFamily: "inherit",
  },
};

export default theme;
